import axios from 'axios';
import { ApiError } from '@app/api/ApiError';
import { deleteAllCookies, persistToken, readRefreshToken, readToken } from '@app/services/cookie.service';
// import { readToken } from '@app/services/localStorage.service';

export const httpApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

httpApi.interceptors.request.use((config) => {
  config.headers = { ...config.headers, Authorization: `Bearer ${readToken()}` };

  return config;
});

// httpApi.interceptors.response.use(undefined, (error: AxiosError) => {
//   throw new ApiError<ApiErrorData>(error.response?.data.message || error.message, error.response?.data);
// });

const handleSessionExpired = () => {
  deleteAllCookies();
  // notificationController.error({ message });
  // setTimeout(() => {
  window.location.href = '/auth/login';
  // }, 3000);
};

httpApi.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    if (err.response.status === 401) {
      const originalRequest = err.config;

      if (originalRequest.url.includes('/auth/refresh-token')) {
        handleSessionExpired();
        return;
      }

      if (originalRequest.url.includes('auth/login') || originalRequest.url.includes('auth/change-password')) {
        throw new ApiError<ApiErrorData>(err.response?.data.message || err.message, err.response?.data);
      }

      if (!originalRequest._retry) {
        originalRequest._retry = true;
        const refreshToken = readRefreshToken();

        if (!refreshToken) {
          handleSessionExpired();
          return;
        }

        try {
          const { data } = await httpApi.post('/auth/refresh-token', {
            refreshToken,
          });

          if (data.statusCode !== 200) {
            handleSessionExpired();
          }
          const newAccessToken = data.token.accessToken;
          persistToken(newAccessToken);
          return httpApi(originalRequest);
        } catch (error) {
          handleSessionExpired();
        }
      }
    }
    if (err.response.status >= 500) {
      return Promise.reject('An error occurred. Please try again later.');
    }
    throw new ApiError<ApiErrorData>(err.response?.data.message || err.message, err.response?.data);
  },
);

export interface ApiErrorData {
  message: string;
}
